export default __webpack_public_path__ + "static/media/tsg-logo.021fa6ef.svg";